export const sizeWidth = {
    xs: '320px',
    sm: '768px',
    md: '992px',
    lg: '1200px'
}

export const sizeHeight = {
    xs: '260px',
    sm: '520px',
    md: '720px',
    lg: '968px'
}

export const deviceMax = {
    xs: `(max-width: ${sizeWidth.xs})`,
    sm: `(max-width: ${sizeWidth.sm})`,
    md: `(max-width: ${sizeWidth.md})`,
    lg: `(max-width: ${sizeWidth.lg})`
}

export const deviceMinHeight = {
    xs: `(min-height: ${sizeHeight.xs})`,
    sm: `(min-height: ${sizeHeight.sm})`,
    md: `(min-height: ${sizeHeight.md})`,
    lg: `(min-height: ${sizeHeight.lg})`
}

export const deviceMaxHeight = {
    xs: `(max-height: ${sizeHeight.xs})`,
    sm: `(max-height: ${sizeHeight.sm})`,
    md: `(max-height: ${sizeHeight.md})`,
    lg: `(max-height: ${sizeHeight.lg})`
}